import React, { useEffect, useRef } from 'react';
import { Drawer } from '@economic/taco';
import { useAppDrawer } from '~/app/shared/components/AppDrawer/AppDrawerContext';
import { useFeatureFlags } from '~/app/shared/featureFlags';

/**
 * A general purpose app drawer that is embedded into the general page layout.
 *
 * - It push in from the right and squeezes the active page.
 * - Each page can use the taco Drawer component to display custom drawer content.
 * - Also used to display help for each page.
 */
export function AppDrawer(): React.JSX.Element | null {
    const ref = useRef<HTMLDivElement>(null);
    const { setWidth } = useAppDrawer();
    const features = useFeatureFlags();

    useEffect(() => {
        if (!ref.current) {
            return () => {};
        }

        const observer = new ResizeObserver(entries => {
            const entry = entries[0]; // We only observe 1 element
            setWidth(entry.contentRect.width);
        });

        observer.observe(ref.current);

        return () => observer.disconnect();
    }, [setWidth]);

    return features.isEnabled('helpDrawer') ? <Drawer.Outlet ref={ref} className="z-10" /> : null;
}
